import * as CONST from 'Reducers/Header/const'
import { CLEAR_ALL_FILTERS } from 'Reducers/Filter/const'

const initState = {
  headerSearch: '',
}

export function header(state = initState, action) {
  switch (action.type) {
    case CONST.HEADER_SEARCH_RESET:
      return {
        ...state,
        headerSearch: '',
      }

    case CONST.HEADER_SEARCH_UPDATE:
      return {
        ...state,
        headerSearch: action.headerSearch,
      }

    case CLEAR_ALL_FILTERS:
      return {
        ...initState,
      }
    default:
      return state
  }
}
